<script>
  // ══════════════════════════════════════════════════════════════════════════
  // ОТКРЫТИЕ КЕЙСА — перенос caseroll.tsx 1:1: лента едет и тормозит на призе.
  // Приз выбирает СЕРВЕР ('caseResult'); нет ответа (витрина) — случайный.
  // Щелчок привязан к фактическому положению ленты (читаем transform кадрово).
  // ══════════════════════════════════════════════════════════════════════════
  import { onMount, onDestroy } from 'svelte';
  import { t } from '../../i18n.js';
  import { roulettePhoto } from '../photofn.js';
  import Photo from '../photo.svelte';
  import Chip from '../ui/chip.svelte';
  import GoldBtn from '../ui/goldbtn.svelte';
  import GhostBtn from '../ui/ghostbtn.svelte';
  import Jc from '../ui/jc.svelte';

  export let items = [];
  export let caseName = undefined;
  export let owned = undefined;
  export let nui = undefined;
  export let onClose = () => {};

  const CELL = 132, GAP = 10, STEP = CELL + GAP;
  // Прокрутка втрое длиннее прежней (просьба владельца) — и путь втрое больше.
  const LANE = 190, WIN_AT = 168, SPIN_MS = 15600, KICK_MS = 60;

  // звук: пул на щелчки, по одному экземпляру на разовые события
  const SFX = 'sfx/';
  const mkAudio = (file, vol) => { try { const a = new Audio(SFX + file); a.volume = vol; return a; } catch (e) { return null; } };
  const tickPool = [];
  let tickAt = 0;
  const playTick = () => {
    if (!tickPool.length) for (let i = 0; i < 6; i++) tickPool.push(mkAudio('roll-tick.wav', 0.35));
    const a = tickPool[tickAt = (tickAt + 1) % tickPool.length];
    try { if (a) { a.currentTime = 0; a.play(); } } catch (e) { /* звук не критичен */ }
  };
  const playOnce = (file, vol) => { const a = mkAudio(file, vol); try { a && a.play(); } catch (e) { } };

  let lane = [];
  let shift = 0;
  let done = false;
  let sold = false;
  let winner = null;
  let stripEl = null;
  let raf = 0, kick = 0;

  const onResultMsg = (e) => {
    const d = e.data || {};
    if (d?.type === 'caseResult' && typeof d.item === 'number') winIdx = d.item;
  };
  let winIdx = 0;

  onMount(() => {
    if (!items.length) return;
    winIdx = Math.floor(Math.random() * items.length);
    window.addEventListener('message', onResultMsg);

    const pick = () => items[Math.floor(Math.random() * items.length)];
    const strip = Array.from({ length: LANE }, pick);

    kick = window.setTimeout(() => {
      const prize = items[winIdx] ?? items[0];
      strip[WIN_AT] = prize;
      winner = prize;
      lane = strip;
      playOnce('roll-start.wav', 0.4);

      requestAnimationFrame(() => requestAnimationFrame(() => {
        const jitter = Math.round((Math.random() - 0.5) * (CELL * 0.5));
        shift = WIN_AT * STEP + CELL / 2 + jitter;

        // щёлкаем ровно тогда, когда мимо указателя проходит новая ячейка
        let lastCell = -1;
        const watch = () => {
          if (stripEl) {
            const m = new DOMMatrixReadOnly(getComputedStyle(stripEl).transform);
            const cell = Math.floor(Math.abs(m.m41) / STEP);
            if (cell !== lastCell) { if (lastCell >= 0) playTick(); lastCell = cell; }
          }
          raf = requestAnimationFrame(watch);
        };
        raf = requestAnimationFrame(watch);
      }));
    }, KICK_MS);
  });

  onDestroy(() => {
    clearTimeout(kick); cancelAnimationFrame(raf);
    window.removeEventListener('message', onResultMsg);
  });

  $: prize = done ? winner : winner;   // как в React: читается после остановки
  $: price = Number(winner?.Price ?? 0);

  const stop = () => { if (!done) { done = true; playOnce('roll-win.wav', 0.5); } };
  // Приз лежит на сервере до подтверждения: «Забрать» и «Продать» — два разных
  // серверных действия, без них выигрыш просто не зачислится.
  const take = () => { playOnce('ui-take.wav', 0.45); nui && nui('casePrizeTake', {}); onClose(); };
  const sell = () => { playOnce('ui-sell.wav', 0.4); sold = true; nui && nui('casePrizeSell', {}); onClose(); };
</script>

<div class="mn-roll" role="dialog" aria-label={t('m.sh.open')}>
  <div class="mn-roll-box">
    <div class="mn-roll-head">
      <span>{done ? t('m.sh.gotIt') : t('m.sh.rolling')}</span>
      {#if caseName}<span class="nm">{caseName}</span>{/if}
      {#if owned != null}<Chip tone="gold">{t('m.sh.owned', { n: owned })}</Chip>{/if}
    </div>

    <div class={'mn-roll-lane' + (done ? ' stopped' : '')}>
      <div class="mn-roll-pin"></div>
      <div
        bind:this={stripEl}
        class="mn-roll-strip"
        style="transform:translateX({-shift}px);transition-duration:{shift ? SPIN_MS + 'ms' : '0ms'}"
        on:transitionend={stop}
      >
        {#each lane as it, i (i)}
          <div class={'mn-roll-cell mn-q' + (it.rarity || 0)}>
            <Photo src={roulettePhoto(it.image)} alt={it.title} icon="cases" />
            <span class="nm">{it.title}</span>
          </div>
        {/each}
      </div>
      <div class="mn-roll-fade l"></div>
      <div class="mn-roll-fade r"></div>
    </div>

    {#if done && winner}
      <div class={'mn-roll-prize mn-q' + (winner.rarity || 0)}>
        <Photo src={roulettePhoto(winner.image)} alt={winner.title} icon="cases" />
        <div class="tx">
          <span class="kk">{t('m.sh.gotIt')}</span>
          <div class="tt">{winner.title}</div>
        </div>
      </div>
    {/if}

    <div class="mn-roll-acts">
      <GoldBtn size="sm" on:click={take} disabled={!done}>{t('m.sh.take')}</GoldBtn>
      {#if price > 0}
        <GhostBtn size="sm" on:click={sell} disabled={!done || sold} class="mn-roll-sell">
          {t('m.sh.sellFor')}<Jc v={price} />
        </GhostBtn>
      {/if}
    </div>
  </div>
</div>
